import { render } from "./Animations.vue?vue&type=template&id=4695d77a"
import script from "./Animations.vue?vue&type=script&lang=js"
export * from "./Animations.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__